import { Box, HBox, VBox } from "../box/Box";
import Spacer from "../spacer/Spacer";
import { Typo, TypoError, TypoMedium } from "../text/Typo";
import { getErrorDetailsText, getFriendlyErrorMessage, unwrapError } from "../../../src/utils/errors";

export const Error = ({ error, sx }: { error?: unknown; sx?: React.CSSProperties }) => {
	const displayError = unwrapError(error);

	if (!displayError) return null;
	const code = displayError.code ?? 0;

	if (code <= -100) return null;

	const displayMessage = getFriendlyErrorMessage(displayError, "Unknown error");
	const detailsText = displayError.details ? getErrorDetailsText(displayError.details) : "";
	const shouldShowDetails =
		![2201, 2203, 2613].includes(code) && detailsText.trim().length > 0 && detailsText.trim() !== displayMessage.trim();

	let errorDetailsNodes = undefined;
	if (shouldShowDetails && Array.isArray(displayError.details)) {
		errorDetailsNodes = (
			<VBox gap="2px">
				{displayError.details.map((val: unknown, index: number) => {
					return (
						<HBox
							key={index}
							gap="10px"
							sx={{
								alignItems: "center",
								"&>div:first-child": {
									backgroundColor: "#e91e63",
									width: "6px",
									height: "6px",
									borderRadius: "50%",
								},
							}}>
							<div></div>
							<Typo capitalize>{String(val).split(",")[0]}</Typo>
						</HBox>
					);
				})}
			</VBox>
		);
	};

	return (
		<Box
			sx={{
				border: "1px solid #F7CACA",
				padding: "12px 14px",
				borderRadius: "9px",
				backgroundColor: "#FFF7F7",
				boxShadow: "0 1px 2px rgba(127, 29, 29, 0.04)",
				...sx,
			}}>
			<TypoError>{displayMessage}</TypoError>
			{code === 2203 && (
				<VBox gap="6px" sx={{ marginTop: "8px", overflowWrap: "anywhere" }}>
					<Typo>Contact support for help with this card holder.</Typo>
					{typeof displayError.card_holder_uid === "string" && (
						<Typo>Card holder ID: {displayError.card_holder_uid}</Typo>
					)}
				</VBox>
			)}
			{shouldShowDetails &&
				(errorDetailsNodes ? (
					errorDetailsNodes
				) : (
					<>
						<Spacer size="6px" />
						<TypoMedium block>{detailsText}</TypoMedium>
					</>
				))}
			{Array.isArray(displayError.stack) && displayError.stack.length > 0 && (
				<>
					<Spacer size="6px" />
					<TypoMedium block>{JSON.stringify(displayError.stack)}</TypoMedium>
				</>
			)}
		</Box>
	);
};
